/* Custom FAQ — accordion expand/collapse + show-more toggle.
   Link-mode items are anchor tags handled by the browser. */
(function () {
  if (customElements.get('custom-faq')) return;

  class CustomFaq extends HTMLElement {
    connectedCallback() {
      this.action = this.dataset.action || 'expand';
      this.singleOpen = this.dataset.singleOpen === 'true';

      if (this.action === 'expand') {
        this.items = Array.from(this.querySelectorAll('[data-card]'));
        this.items.forEach((item) => {
          const btn = item.querySelector('[data-toggle]');
          if (btn) btn.addEventListener('click', () => this._toggle(item));
        });
      }

      // Show more button lives as a sibling of <custom-faq>; the
      // section markup ensures it sits right after this element.
      this.moreBtn = this.parentElement && this.parentElement.querySelector('[data-more]');
      if (this.moreBtn) {
        this.moreBtn.addEventListener('click', () => this._toggleMore());
      }
    }

    _toggle(item) {
      const isOpen = item.dataset.expanded === 'true';
      if (this.singleOpen && !isOpen) {
        this.items.forEach((other) => {
          if (other !== item) this._setExpanded(other, false);
        });
      }
      this._setExpanded(item, !isOpen);
    }

    _setExpanded(item, expanded) {
      item.dataset.expanded = expanded ? 'true' : 'false';
      const btn = item.querySelector('[data-toggle]');
      if (btn) btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    }

    _toggleMore() {
      const hidden = this.querySelectorAll('[data-hidden="true"]');
      if (!hidden.length) {
        // Currently expanded — collapse back to initial state.
        const initial = parseInt(this.dataset.initial, 10) || 0;
        const all = Array.from(this.children).filter((c) => c.classList.contains('custom-faq__item'));
        all.forEach((el, i) => {
          if (i >= initial) {
            el.classList.add('is-hidden');
            el.setAttribute('data-hidden', 'true');
          }
        });
        this.moreBtn.textContent = this.moreBtn.dataset.moreText || 'View more';
      } else {
        hidden.forEach((el) => {
          el.classList.remove('is-hidden');
          el.removeAttribute('data-hidden');
        });
        this.moreBtn.textContent = this.moreBtn.dataset.lessText || 'Show less';
      }
    }
  }

  customElements.define('custom-faq', CustomFaq);
})();
